import { activityEntry, roleEntry, skillEntry, skillExplorerStore, skillsetEntry } from '@app/Store/skill-explorer-store.js';
import { novaLocalize } from '@shared/l10n/localize.js';

let listening = false;

const resolveContext = e => e.composedPath().find(node => node?.skillSet || node?.jobRole || node?.activity) ?? null;

const buildEntry = e => {
  const { skill, remainder } = e.detail ?? {};
  if (skill && !remainder) {
    return skillEntry(skill);
  }

  const context = resolveContext(e);
  if (context?.skillSet) {
    return skillsetEntry({ ...context.skillSet, skills: context.skills ?? [] });
  }
  if (context?.jobRole) {
    return roleEntry({ ...context.jobRole, skills: context.skills ?? [] });
  }
  return context?.activity ? activityEntry(context.activity) : null;
};

export const initSkillExplorerListener = session => {
  if (listening) {
    return;
  }
  listening = true;

  document.addEventListener('sw-skill-chip-click', async e => {
    const entry = buildEntry(e);
    if (!entry) {
      return;
    }

    const wasClosed = !skillExplorerStore.isOpen;
    skillExplorerStore.navigate(entry);

    if (wasClosed) {
      await import('../components/skills/skill-explorer/skill-explorer.js');
      session.openDrawer({ content: document.createElement('skill-explorer'), bare: true, label: novaLocalize('skill-explorer.label'), width: '600px' });
    }
  });
};
